import ApiService from "@/common/api.service";
import {
  FETCH_FAULT_MESSAGES,
  FETCH_FAULT_MESSAGE,
  UPDATE_FAULT_MESSAGE,
  CREATE_FAULT_MESSAGE,
  RESET_FAULT_MESSAGE,
  DELETE_FAULT_MESSAGE
} from "./actions.type";
import {
  FETCH_FAULT_MESSAGE_START,
  SET_FAULT_MESSAGES,
  SET_FAULT_MESSAGE
} from "./mutations.type";

const state = {
  faultMessages: [],
  faultMessagesCount: 1,
  faultMessage: {},
  isLoading: false
};

const getters = {
  faultMessagesCount: state => state.faultMessagesCount,
  faultMessages: state => state.faultMessages,
  faultMessage: state => state.faultMessage,
  faultMessageIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_FAULT_MESSAGES]({ commit }, [filteringCriteria, search]) {
    commit(FETCH_FAULT_MESSAGE_START);
    return ApiService.filteredCollection(
      "fault-messages",
      filteringCriteria,
      search
    ).then(({ data }) => {
      commit(SET_FAULT_MESSAGES, data);
    });
  },
  [FETCH_FAULT_MESSAGE](context, id) {
    return ApiService.get("fault-messages", id).then(({ data }) => {
      context.commit(SET_FAULT_MESSAGE, data);
    });
  },
  [UPDATE_FAULT_MESSAGE](context, payload) {
    return ApiService.put(`fault-messages/${payload.id}`, payload);
  },
  [CREATE_FAULT_MESSAGE](context, payload) {
    return ApiService.post("fault-messages", payload);
  },
  [RESET_FAULT_MESSAGE](context) {
    context.commit(SET_FAULT_MESSAGE, {});
  },
  [DELETE_FAULT_MESSAGE](context, id) {
    return ApiService.delete("fault-messages", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_FAULT_MESSAGE_START](state) {
    state.isLoading = true;
  },
  [SET_FAULT_MESSAGES](state, data) {
    state.faultMessages = data.items || [];
    state.faultMessagesCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_FAULT_MESSAGE](state, data) {
    state.faultMessage = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
